import { render, staticRenderFns } from "./EmployeeModule.vue?vue&type=template&id=5ee54581&"
import script from "./EmployeeModule.vue?vue&type=script&lang=js&"
export * from "./EmployeeModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports